const LoadingRing = ({ color = 'white', size = 64 }) => {
  const ringStyle = {
    width: size,
    height: size,
    borderWidth: size / 8,
    borderTopColor: color
  }

  return (
    <div className="lds-ring-wrap">
      <div
        className="lds-ring"
        style={{ width: size + size / 4, height: size + size / 4 }}
      >
        {[...Array(4)].map((_, index) => (
          <div key={index} style={ringStyle} />
        ))}
      </div>
    </div>
  )
}

export default LoadingRing
